// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"501":"e6e9a6e5401884e3e092","940":"9f6df4eb3a6d72633f92"}[chunkId] + ".css";
};